import styled from 'styled-components';

import { Container } from 'components/Container';

export const CopyContainer = styled(Container).attrs(() => ({
  background: 'white',
  padding: 1,
  manageLayout: false,
}))`
  font-size: ${props => props.theme.fontSize.xxxs};
  line-height: 5rem;
  text-align: center;
`;
